import useAuth from "@irati/auth/helpers/auth/useAuth"

export function useBudgetsPermissions() {
  const {productPermissions: auth} = useAuth()
  const canBudget = !!auth?.wallet?.flexiRewards?.budget
  const isBudgetAdmin = canBudget && !!auth?.admin
  const canManageCategories = canBudget && !!auth?.wallet?.flexiRewards?.budget?.manageCategory

  return {
    isBudgetAdmin,
    canBudget,
    canManageCategories,
    canViewCompanyBudgets: canManageCategories
  }
}
